// extracted by mini-css-extract-plugin
export var dropdown = "_ew-0";
export var imagePlaceholder = "_ew-2";
export var imageWrapper = "_ew-3";
export var productImage = "_ew-1";
export var truncateContainer = "_ew-4";
export var truncateText = "_ew-5";